/*! For license information please see XmlBeautify.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.XmlBeautify = t() : e.XmlBeautify = t();
}(this, () => (() => {
  "use strict";

  var e = {
      d: (t, n) => {
        for (var r in n) e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {
          enumerable: !0,
          get: n[r]
        });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t)
    },
    t = {};
  function n(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  e.d(t, {
    default: () => r
  });
  var r = function () {
    function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
      var n = t || {};
      this.userExternalParser = !1, n.parser ? (this.userExternalParser = !0, this.parser = new n.parser()) : this.parser = new DOMParser();
    }
    var t, r, l;
    return t = e, (r = [{
      key: "hasXmlDef",
      value: function (e) {
        return e.indexOf("<?xml") >= 0;
      }
    }, {
      key: "getEncoding",
      value: function (e) {
        if (!this.hasXmlDef(e)) return null;
        var t = e.toLowerCase().indexOf('encoding="') + 'encoding="'.length,
          n = e.indexOf('"?>');
        return e.substr(t, n - t);
      }
    }, {
      key: "_children",
      value: function (e) {
        for (var t = [], n = e.childNodes.length, r = 0; r < n; r++) 1 === e.childNodes[r].nodeType && t.push(e.childNodes[r]);
        return t;
      }
    }, {
      key: "beautify",
      value: function (e, t) {
        var n = this,
          r = n.parser.parseFromString(e, "text/xml"),
          l = "  ",
          a = !1;
        t && (t.indent && (l = t.indent), 1 == t.useSelfClosingElement && (a = t.useSelfClosingElement));
        var i = null;
        n.hasXmlDef(e) && (i = '<?xml version="1.0" encoding="' + n.getEncoding(e) + '"?>');
        var o = {
          indentText: l,
          xmlText: "",
          useSelfClosingElement: a,
          indentLevel: 0
        };
        n.userExternalParser ? n._parseInternally(this._children(r)[0], o) : n._parseInternally(r.children[0], o);
        var s = "";
        return i && (s += i + "\n"), s += o.xmlText;
      }
    }, {
      key: "_parseInternally",
      value: function (e, t) {
        var n,
          r = this,
          l = e.textContent;
        0 == l.replace(/ /g, "").replace(/\r?\n/g, "").replace(/\n/g, "").replace(/\t/g, "").length && (l = ""), n = r.userExternalParser ? !(r._children(e).length > 0) : !(e.children.length > 0);
        var a = l && l.length > 0,
          i = n && a,
          o = n && !a,
          s = t.useSelfClosingElement,
          d = "";
        if (i) {
          var c = r._getFirstCDATAChild(e),
            u = c.hasCDATAChild,
            h = c.content;
          d += u ? h : l;
        }
        for (var f, x = "", p = 0; p < t.indentLevel; p++) x += t.indentText;
        t.xmlText += x, t.xmlText += "<" + e.tagName;
        for (var g = 0; g < e.attributes.length; g++) {
          var v = e.attributes[g];
          t.xmlText += " " + v.name + '="' + v.textContent + '"';
        }
        t.xmlText += o && s ? " />" : ">", i ? t.xmlText += d : o && !s || (t.xmlText += "\n"), t.indentLevel++, f = r.userExternalParser ? r._children(e).length : e.children.length;
        for (var m = 0; m < f; m++) {
          var y = void 0;
          y = r.userExternalParser ? r._children(e)[m] : e.children[m], r._parseInternally(y, t);
        }
        if (t.indentLevel--, o) {
          if (s) ;else {
            var T = "</" + e.tagName + ">";
            t.xmlText += T, t.xmlText += "\n";
          }
        } else {
          var C = "</" + e.tagName + ">";
          n && a || (t.xmlText += x), t.xmlText += C, t.xmlText += "\n";
        }
      }
    }, {
      key: "_getFirstCDATAChild",
      value: function (e) {
        for (var t = e.childNodes.length, n = "", r = !1, l = 0; l < t; l++) 3 === e.childNodes[l].nodeType ? e.childNodes[l].data.replace(/ /g, "").replace(/\r?\n/g, "").replace(/\n/g, "").replace(/\t/g, "").length > 0 && (n += e.childNodes[l].data) : 4 === e.childNodes[l].nodeType && (n += "<![CDATA[", n += e.childNodes[l].data, n += "]]>", r = !0);
        return r ? {
          hasCDATAChild: !0,
          content: n
        } : {
          hasCDATAChild: !1
        };
      }
    }]) && n(t.prototype, r), l && n(t, l), Object.defineProperty(t, "prototype", {
      writable: !1
    }), e;
  }();
  return t = t.default;
})());